module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/d297d508e1306d0218eca477ed087394.png";